import type { TreatmentAreasAttributes } from '../../../types/cms'
import { useState } from 'react'
import { MarkdownText } from 'ui-kit'
import FormattedImage from '../../FormattedImage'
import { Grid } from '@mui/material'
import { ButtonContainer, TabLabel, TreatmentAreasContainer } from './styles'

const TreatmentAreas = ({ title, items }: TreatmentAreasAttributes) => {
  const [activeImage, setActiveImage] = useState(0)

  const areas = items?.map(({ tabText }) => tabText) ?? []
  const itemCount = items?.length ?? 0

  return (
    <TreatmentAreasContainer>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <Grid item>
          <MarkdownText>{title}</MarkdownText>
        </Grid>
        <Grid item>
          <FormattedImage
            image={
              itemCount > 1 ? items?.[activeImage]?.image : items?.[0]?.image
            }
          />
        </Grid>
      </Grid>
      {itemCount > 1 && (
        <ButtonContainer>
          {areas.map((area, idx) => (
            <button
              onClick={() => setActiveImage(idx)}
              key={area}
              type="button"
            >
              <TabLabel isActive={activeImage === idx}>{areas[idx]}</TabLabel>
            </button>
          ))}
        </ButtonContainer>
      )}
    </TreatmentAreasContainer>
  )
}

export default TreatmentAreas
